export const TALKS_PLAYLIST_URL =
  "https://www.youtube.com/playlist?list=PLvMEdv7wBhWkVGHOacHvvqkqV_Z_4Oxkf"
